import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["compactSize", "menuItem", "onClick", "styleText", "subMenu", "subMenuButtonLabel"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useState, useContext } from 'react';
import classnames from 'classnames/bind';
import { Button } from "../../Button/Button/Button";
import Colors from "../../Color/Colors";
import { Icon } from "../../Icon/Icon/Icon";
import { ThemeContext, defaultThemeContext } from "../../../context/theme.context";
import Utility from "../../Utility/Utility";
import styles from "./MenuItem.module.scss";

// Classnames bind variant
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var cx = classnames.bind(styles);
export var MenuItem = function MenuItem(_ref) {
  var _menuItem$url;
  var _ref$compactSize = _ref.compactSize,
    compactSize = _ref$compactSize === void 0 ? false : _ref$compactSize,
    menuItem = _ref.menuItem,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return false;
    } : _ref$onClick,
    _ref$styleText = _ref.styleText,
    styleText = _ref$styleText === void 0 ? '' : _ref$styleText,
    _ref$subMenu = _ref.subMenu,
    subMenu = _ref$subMenu === void 0 ? [] : _ref$subMenu,
    _ref$subMenuButtonLab = _ref.subMenuButtonLabel,
    subMenuButtonLabel = _ref$subMenuButtonLab === void 0 ? 'Expand sub menu' : _ref$subMenuButtonLab,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var theme = useContext(ThemeContext);
  var isSubMenu = subMenu && subMenu.length !== 0 && (menuItem === null || menuItem === void 0 ? void 0 : (_menuItem$url = menuItem.url) === null || _menuItem$url === void 0 ? void 0 : _menuItem$url.length) === 0;
  var themeSelected = theme || defaultThemeContext;
  var iconColorProcessed = themeSelected === 'lightBackground' ? Colors.colorWW100 : Colors.colorWhite;
  var renderedChildren = menuItem !== null && menuItem !== void 0 && menuItem.hideText ? /*#__PURE__*/_jsx("span", {
    className: styles.hideText,
    children: Utility.dangerousHTML(menuItem === null || menuItem === void 0 ? void 0 : menuItem.text)
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: Utility.dangerousHTML(menuItem === null || menuItem === void 0 ? void 0 : menuItem.text)
  });
  var renderedSubtitle = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.subtitle) && /*#__PURE__*/_jsx("span", {
    className: styles.subtitle,
    children: Utility.dangerousHTML(menuItem === null || menuItem === void 0 ? void 0 : menuItem.subtitle)
  });
  var accessibilityLabel = "".concat(menuItem !== null && menuItem !== void 0 && menuItem.hideText ? menuItem !== null && menuItem !== void 0 && menuItem.text ? menuItem.text : '' : '', " ").concat(isSubMenu ? subMenuButtonLabel : '').trim();
  return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    className: [cx({
      menuItemCompact: compactSize,
      menuItemDarkBackground: themeSelected === 'darkBackground',
      menuItemLink: true,
      menuItemLinkActive: menuItem === null || menuItem === void 0 ? void 0 : menuItem.active,
      menuItemLinkActiveTrail: menuItem === null || menuItem === void 0 ? void 0 : menuItem.activeTrail
    }), styleText].join(' '),
    onHover: setIsHovered,
    onClick: onClick,
    type: "no-style",
    url: menuItem === null || menuItem === void 0 ? void 0 : menuItem.url,
    newWindow: menuItem === null || menuItem === void 0 ? void 0 : menuItem.newWindow,
    title: Utility.getLinkTitleText(menuItem !== null && menuItem !== void 0 && menuItem.text ? menuItem.text : '', menuItem === null || menuItem === void 0 ? void 0 : menuItem.title),
    accessibilityLabel: accessibilityLabel,
    attributes: menuItem === null || menuItem === void 0 ? void 0 : menuItem.attributes
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs("span", {
      className: cx({
        menuItemInnerWrapper: true,
        menuItemInnerWrapperWithIcon: menuItem === null || menuItem === void 0 ? void 0 : menuItem.icon
      }),
      "data-e2e-name": Utility.formatCustomAttribute(menuItem !== null && menuItem !== void 0 && menuItem.text ? menuItem === null || menuItem === void 0 ? void 0 : menuItem.text : ''),
      children: [(menuItem === null || menuItem === void 0 ? void 0 : menuItem.icon) && /*#__PURE__*/_jsx("span", {
        className: styles.menuItemIconWrapper,
        children: /*#__PURE__*/_jsx(Icon, {
          type: isHovered && menuItem !== null && menuItem !== void 0 && menuItem.iconHover && themeSelected === defaultThemeContext ? menuItem.iconHover : menuItem === null || menuItem === void 0 ? void 0 : menuItem.icon,
          width: "20px",
          height: "20px",
          fill: iconColorProcessed,
          noFill: menuItem === null || menuItem === void 0 ? void 0 : menuItem.noFill
        })
      }), renderedChildren, renderedSubtitle, isSubMenu && /*#__PURE__*/_jsx("div", {
        className: styles.menuItemAngleWrapper,
        children: /*#__PURE__*/_jsx(Icon, {
          fill: iconColorProcessed,
          height: "20px",
          type: "arrow-down",
          width: "20px"
        })
      })]
    })
  }));
};